import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { createChart, LineSeries, ColorType, CrosshairMode, IChartApi } from 'lightweight-charts';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { ModeloMercadoInterface } from 'src/app/interface/ModeloMercadoInterface';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { SseService } from 'src/app/services/SseService';
import { TemaService } from 'src/app/services/tema.services';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-informe',
  templateUrl: './informe.component.html',
  styleUrl: './informe.component.scss'
})
export class InformeComponent implements OnInit, OnDestroy, AfterViewInit {
  public licencia: string;
  public optimaWallet: OptimalWallet;
  public subscription: Subscription;
  public dataSourceoptima: OptimalWallet[] = [];
  public nombre: string;
  public descripcion: string;
  public listModeloMercado: ModeloMercadoInterface[] = [];
  listModelo: CdkTableVirtualScrollDataSource<any>;
  public isLoading: boolean = false;
  public primero: boolean = true;
  public idCarteras: number[] = [0, 0, 0, 0, 0];
  public dataLine1: any;
  public retroceso: any;
  public retrocesopor: any;
  public periodos: any;
  public modeloActualizado: any;
  public listaMercados: any;
  public rendAnual: any;
  public riesgo: any;
  public rentabilidad: any;
  private lwcChart: IChartApi | undefined;
  private tooltipEl: HTMLElement | undefined;
  private resizeObserver: ResizeObserver | undefined;
  backgroundColor: string;
  color: string;
  public theme: string;
  public isDark: boolean = false;
  public subtema: Subscription;
  public dataCompleta: boolean=false;
  public originalTheme: string;


  displayedColumns: string[] = ['nombre', 'checkbox','eliminar'];
  displayedColumnsModelo: string[] = ['cartera', 'fechaInicio', 'nombreMercado', 'nombrePeriodo', 'bajista', 'condicion'];
  tableColumnsRend: TableColmuns[] = [
    { id: 'id', name: 'id', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'idcartera', name: 'idcartera', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'annio', name: 'Año', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'rendimiento', name: 'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'porcentajerendimiento', name: 'Beneficio %', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorliquidativo', name: 'valor Liquidativo', isShow: true, isDate: false, isNumber: true, isString: false },
  ]

  displayedColumnsRend: string[] = ['annio', 'porcentajerendimiento', 'rendimiento', 'valorliquidativo'];
  tableColumnsRR: TableColmuns[] = [
    { id: 'nombre', name: 'Nombre', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'dato', name: 'Dato', isShow: true, isDate: false, isNumber: true, isString: false },
  ]

  displayedColumnsRR: string[] = ['nombre', 'dato'];

  constructor(private _sseservice: SseService,
    private _cookieService: CookieService,private temaservicio: TemaService,
    private cdr: ChangeDetectorRef,
    private _diversificadorSV: DiversificadorService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InformeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    private el: ElementRef
  ) {

  }
  ngAfterViewInit(): void {
    
    this.document.body.classList.add(this.originalTheme);


   console.log("dialogRef dialogRef");


  }

  ngOnDestroy(): void {
    this.subtema.unsubscribe();
    this.destroyChart();
  }
  ngOnInit(): void {
      this.licencia = this._cookieService.get('auth_token');
  //   this.theme = this._cookieService.get('theme');
      console.log(this.dialogRef);
      this.listarInforme();
      this._sseservice.apiPostNew('parametricaparamodelos', null, this.licencia).subscribe({
        next: (data: any) => {
          this.periodos = data.periodos;
          console.log("ESTSO SON LOS PERIODOS: ", this.periodos);
        }
      });//
      this._sseservice.apiPostNew('listamercados', null, this.licencia).subscribe({
        next: (data: any) => {
          this.listaMercados = data;
          console.log("ESTSO SON LOS listaMercados: ", this.listaMercados);
        }
      });
      this.subtema = this.temaservicio.valDarkTheme.subscribe({
        next: (data: any) => {
          this.isDark = data;
          this.theme = data ? 'dark-theme' : 'light-theme';
          this.applyThemeColors();
          this.updateChartTheme();
        }
      });
      this.originalTheme = this.data.originalTheme;
    // Initialize theme colors
    this.applyThemeColors();
      console.log("this.originalTheme ",this.originalTheme)
  }

  listarInforme(){
    this._sseservice.apiPostNew('listarcarteras', null, this.licencia).subscribe(response => {
      let data = response;
      data = data.filter((item: { subCarteras: string; }) => item.subCarteras !== "");
      this.listModelo = new CdkTableVirtualScrollDataSource(data);
      console.log("listar informe: ", data);
    });
  }

  onRowCheckboxChange(row: any) {
    console.log(row);
    if (row.subCarteras !== '') {
    
      let arrayOfNumbers: number[] = row.subCarteras.split(',').map(Number);
      arrayOfNumbers.forEach(number => {
        if (this.idCarteras.indexOf(number) === -1) {
          const primerCeroIndex = this.idCarteras.indexOf(0);
          if (primerCeroIndex !== -1) {
            this.idCarteras[primerCeroIndex] = number;
          }
        }
      });
      console.log(arrayOfNumbers); 
    }else{
      const index = this.idCarteras.indexOf(row.idcartera);
      if (index !== -1) {
        this.idCarteras[index] = 0;
      } else {
        const primerCeroIndex = this.idCarteras.indexOf(0);
        if (primerCeroIndex !== -1) {
          this.idCarteras[primerCeroIndex] = row.idcartera;
        }

      }
    }
    this.optimaWallet = row;
    this.cargarModelo(this.idCarteras);
    console.log("lista Modelo: ", this.idCarteras);
    let todosCeros: boolean = this.idCarteras.every(numero => numero === 0);
    if (todosCeros) {
      this.dataCompleta=false;
      console.log("todos son cero");
    }
    this.recalcularPonderador(this.idCarteras, row)

  }

  cargarModelo(idCarteras: any) {
    const string = idCarteras.join(',');
    let url = 'parametrosmodelos?idcarteras=' + string;
    console.log("esto es el url ", url);
    this._sseservice.apiGetNew(url).subscribe({
      next: (data: any) => {

        this.listModeloMercado = data;
        console.log(this.listModeloMercado);
        this.modeloActualizado = this.listModeloMercado.map(item => {
          const mercado = this.listaMercados.find((m: { idmercado: number; }) => m.idmercado === item.idMercado);
          const periodo = this.periodos.find((p: { idperiodo: number; }) => p.idperiodo === item.periodo);
          return {
            ...item,
            nombreMercado: mercado ? mercado.iso : 'Desconocido',
            nombrePeriodo: periodo ? periodo.periodo : 'Desconocido',
          };

        });
        console.log("Esta es la lista ACtualizada: ", this.modeloActualizado);
      }
    });
  }

  isIdSelected(id: number): boolean {
    return this.idCarteras.includes(id);
  }

  recalcularPonderador(array: any, cartera: any) {

    console.log("Evento desde Lista: ", array);
    this.optimaWallet.idCarteras = array;
    this.optimaWallet.idModelo = 0;
    this.optimaWallet.idcartera=0;
    //this.optimaWallet.bajista = false;
    console.log("CARTERA SEGUNDA: ", this.optimaWallet);
    let todosCeros: boolean = this.optimaWallet.idCarteras.every(numero => numero === 0);
    if (todosCeros) {
      this.inicializarDataDiversificador();
    } else
      this.getOptimalWallet(this.optimaWallet, 'Recalcular?');
  }

  inicializarDataDiversificador() {
    this.rentabilidad = [];
    this.riesgo = [];
    this.rendAnual=[];
    this.modeloActualizado=[];
  }

  getOptimalWallet(data: any, endpoint: string) {

    let rentabilida: any[] = [];
    let riesgo: any[] = [];
    let rendimiendoAnual: any[] = [];

    this.isLoading = true;
    this._sseservice.apiGetSse(endpoint, true, data).subscribe({
      next: (resp: any) => {
        if (resp.name === 'ope') {

          var temp = resp.data[resp.data.length - 1];
          this.optimaWallet.margen = parseFloat(parseFloat(temp.margentotal).toFixed(2));
          this.optimaWallet.fondosDisponibles = parseFloat(parseFloat(temp.fondosdisponibles).toFixed(2));
          this.optimaWallet.poderCompra = parseFloat(parseFloat(temp.podercompra).toFixed(2));
          this.optimaWallet.efectivo = parseFloat(parseFloat(temp.efectivo).toFixed(2));
          this.optimaWallet.valorLiquidativo = parseFloat(parseFloat(temp.valorliquidativo).toFixed(2));

        } else if (resp.name === 'ren') {
          rentabilida.push(resp.data);
          console.log("RENTABILIDAD", resp.data);
          this.rentabilidad = resp.data;
        } else if (resp.name === 'rie') {
          riesgo.push(resp.data);
          console.log("RIESGO", resp.data);
          this.riesgo = resp.data;
        } else if (resp.name === 'rea') {
          rendimiendoAnual.push(resp.data);
          console.log("RENDIMIENTO ANUAL", resp.data);
          this.rendAnual = resp.data;
        }
      }, error(err) {
        console.log("hubo un error")
      }, complete: () => {
        this.isLoading = false;
        //aqui se ejecutaria la grafica
        this.fetchData(this.optimaWallet.idCarteras);
        this.dataCompleta=true;
        this.cdr.detectChanges();
        //this.dataSourceoptima.push(this.optimaWallet);
      }
    });
  }

  async fetchData(idCarteras: any) {
    let url = 'obtenerDatosGraficaRendimientos?idcartera=0&idcarteras=' + idCarteras + '&valorriesgo=' + encodeURIComponent(String(this.optimaWallet?.riesgo ?? ''));
    try {
      const Datos = await this._sseservice.apiGetNew(url).toPromise();
      this.dataLine1 = JSON.parse(Datos.data);
      this.retroceso = JSON.parse(Datos.retroceso);
      this.retrocesopor = JSON.parse(Datos.retrocesopor);
      if (document.getElementById('containerPDF')) {
        await this.createChart(this.dataLine1, this.retroceso,this.retrocesopor, 'containerPDF');
      }
    }
    catch (error) {
      console.error('Error al recuperar datos:', error);
    }
  }

  async createChart(data: any, retroceso: any, retrocesopor: any, div: string) {
    const container = document.getElementById(div);
    if (!container) return;

    this.destroyChart();

    const c = this.getColors(this.isDark);
    const d0 = this.convertData(data);
    const d1 = this.convertData(retroceso);
    const d2 = this.convertData(retrocesopor);

    const chart = createChart(container, {
      layout: {
        background: { type: ColorType.Solid, color: c.bg },
        textColor: c.text,
      },
      grid: {
        vertLines: { color: c.grid },
        horzLines: { color: c.grid },
      },
      crosshair: { mode: CrosshairMode.Normal },
      timeScale: { borderColor: c.border, timeVisible: true },
      rightPriceScale: {
        borderColor: c.border,
        visible: true,
        scaleMargins: { top: 0.1, bottom: 0.02 },
      },
    });

    const s0 = chart.addSeries(LineSeries, {
      color: '#2196f3',
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: true,
      title: 'Valor Liquidativo',
    });
    s0.setData(d0);

    const pane1 = (chart as any).addPane({ height: 80 });
    const s1 = pane1.addSeries(LineSeries, {
      color: this.isDark ? '#ef5350' : 'red',
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: true,
      title: 'Retroceso',
    });
    s1.setData(d1);

    const pane2 = (chart as any).addPane({ height: 80 });
    const s2 = pane2.addSeries(LineSeries, {
      color: this.isDark ? '#26a69a' : 'green',
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: true,
      title: 'Retroceso %',
    });
    s2.setData(d2);

    this.lwcChart = chart;

    container.style.position = 'relative';
    const tooltip = document.createElement('div');
    tooltip.style.cssText = 'position:absolute;top:4px;left:4px;z-index:10;pointer-events:none;' +
      'background:rgba(0,0,0,0.72);color:#fff;padding:6px 10px;border-radius:4px;font-size:12px;display:none;line-height:1.6;';
    container.appendChild(tooltip);
    this.tooltipEl = tooltip;

    const dataStore = { d0, d1, d2 };
    const fmtTime = (t: any): string => {
      if (!t) return '';
      if (typeof t === 'string') return t;
      if (typeof t === 'object' && t.year != null)
        return `${t.year}-${String(t.month).padStart(2, '0')}-${String(t.day).padStart(2, '0')}`;
      if (typeof t === 'number') return new Date(t * 1000).toISOString().slice(0, 10);
      return '';
    };

    chart.subscribeCrosshairMove((param: any) => {
      if (!param?.point || param.point.x < 0 || param.point.y < 0) {
        tooltip.style.display = 'none';
        return;
      }
      const time = chart.timeScale().coordinateToTime(param.point.x);
      const timeKey = fmtTime(time);
      if (!timeKey) { tooltip.style.display = 'none'; return; }

      const val0 = dataStore.d0.find((x: any) => x.time === timeKey);
      const val1 = dataStore.d1.find((x: any) => x.time === timeKey);
      const val2 = dataStore.d2.find((x: any) => x.time === timeKey);

      let html = `<div style="margin-bottom:2px;font-weight:bold;">${timeKey}</div>`;
      if (val0) html += `<div><span style="color:#2196f3">●</span> Val. Liq: <b>${Number(val0.value).toFixed(4)}</b></div>`;
      if (val1) html += `<div><span style="color:#ef5350">●</span> Retroceso: <b>${Number(val1.value).toFixed(4)}</b></div>`;
      if (val2) html += `<div><span style="color:#26a69a">●</span> Retroceso %: <b>${Number(val2.value).toFixed(4)}</b></div>`;

      tooltip.innerHTML = html;
      tooltip.style.display = 'block';
    });

    const ro = new ResizeObserver(entries => {
      const entry = entries[0];
      const w = entry?.contentRect?.width || container.clientWidth;
      const h = entry?.contentRect?.height || container.clientHeight;
      if (w > 0 && h > 0) { try { chart.resize(w, h); } catch {} }
    });
    ro.observe(container);
    this.resizeObserver = ro;

    chart.timeScale().fitContent();
  }

  private convertData(raw: any[]): any[] {
    if (!Array.isArray(raw)) return [];
    return raw
      .filter((p: any) => Array.isArray(p) && p.length >= 2 && Number.isFinite(Number(p[1])))
      .map((p: any) => ({ time: new Date(Number(p[0])).toISOString().slice(0, 10), value: Number(p[1]) }))
      .sort((a: any, b: any) => a.time.localeCompare(b.time))
      .reduce((acc: any[], item: any) => {
        if (!acc.length || acc[acc.length - 1].time !== item.time) acc.push(item);
        return acc;
      }, []);
  }

  private getColors(isDark: boolean) {
    return {
      bg: isDark ? '#1e222d' : '#ffffff',
      text: isDark ? '#d1d4dc' : '#000000',
      grid: isDark ? '#2a2e39' : '#e6e6e6',
      border: isDark ? '#3a3f4b' : '#ccd6eb',
    };
  }

  private destroyChart() {
    if (this.resizeObserver) { this.resizeObserver.disconnect(); this.resizeObserver = undefined; }
    if (this.tooltipEl?.parentElement) { this.tooltipEl.parentElement.removeChild(this.tooltipEl); this.tooltipEl = undefined; }
    if (this.lwcChart) { try { this.lwcChart.remove(); } catch {} this.lwcChart = undefined; }
  }

  private applyThemeColors() {
    this.backgroundColor = this.isDark ? '#1e222d' : '#ffffff';
    this.color = this.isDark ? '#d1d4dc' : '#000000';
  }

  updateChartTheme() {
    if (!this.lwcChart) return;
    this.applyThemeColors();
    const c = this.getColors(this.isDark);
    this.lwcChart.applyOptions({
      layout: {
        background: { type: ColorType.Solid, color: c.bg },
        textColor: c.text,
      },
      grid: {
        vertLines: { color: c.grid },
        horzLines: { color: c.grid },
      },
    });
  }

  downloadPDF() {
    const DATA: any = document.getElementById('htmlData1');
    const DATA2: any = document.getElementById('htmlData2');

    // Forzar tema claro global mientras se captura el PDF
    this.document.body.classList.remove(this.originalTheme);
    this.document.body.classList.add('light-theme');
    const doc = new jsPDF('p', 'pt', 'a4');
    const options = {
      background: 'white',
      scale: 1,
      style: {
        color: '#000000', // Establece el color del texto en negro (#000000)
        backgroundColor: '#ffffff'
      }
    };
    html2canvas(DATA, options).then((canvas) => {
      const img1 = canvas.toDataURL('image/PNG');

      // Capturar la segunda imagen (Segunda página)
      return html2canvas(DATA2, options).then((canvas2) => {
        const img2 = canvas2.toDataURL('image/PNG');

        // Add image Canvas to PDF (Primera página)
        const bufferX = 15;
        const bufferY = 15;
        const imgProps1 = (doc as any).getImageProperties(img1);
        const pdfWidth1 = doc.internal.pageSize.getWidth() - 2 * bufferX;
        const pdfHeight1 = (imgProps1.height * pdfWidth1) / imgProps1.width;
        doc.addImage(img1, 'PNG', bufferX, bufferY, pdfWidth1, pdfHeight1, undefined, 'FAST');

        // Agregar nueva página (Segunda página)
        doc.addPage();

        // Add image Canvas to PDF (Segunda página)
        const imgProps2 = (doc as any).getImageProperties(img2);
        const pdfWidth2 = doc.internal.pageSize.getWidth() - 2 * bufferX;
        const pdfHeight2 = (imgProps2.height * pdfWidth2) / imgProps2.width;
        doc.addImage(img2, 'PNG', bufferX, bufferY, pdfWidth2, pdfHeight2, undefined, 'FAST');

        return doc;
         
      });
    }).then((docResult) => {

      docResult.save(`${new Date().toISOString()}_informe_Modelo.pdf`);
      this.document.body.classList.remove('light-theme');
      this.document.body.classList.add(this.originalTheme);
      this.dialogRef.close();
    });
   
  }

  eliminarCartera(row: any){
    console.log("ESTO SE VA A ELIMINAR: ", row);
  
   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '150px',
        panelClass: this.theme,
        data: {
          msj: '!Atención! el Informe será eliminado.'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        if (result) {
          const idcartera = {
            idcartera: Number(row.idcartera )//conversar con jorge
          };
          this._sseservice.apiPostNew('eliminarcartera',idcartera, this.licencia).subscribe(response =>{
            console.log(response);
            this.listarInforme()
          });
        } else {
        
          console.log('La acción fue cancelada');
        }
      }); 
  }


}
